export default "__VITE_ASSET__pQ9deUlV__"